import React, { useState, useEffect, useRef } from "react";

const wrapperStyle = {
  position: "relative",
  width: "100%",
};

const inputStyle = {
  width: "100%",
  padding: "8px 12px",
  height: 40,
  borderRadius: 4,
  border: "1px solid #E6EDFF",
  background: "#FAFAFB",
  fontSize: 14,
  boxSizing: "border-box",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  cursor: "text",
};

const arrowStyle = isOpen => ({
  position: "absolute",
  right: 12,
  top: "50%",
  transform: `translateY(-50%) rotate(${isOpen ? 180 : 0}deg)`,
  fontSize: 12,
  cursor: "pointer",
  color: "#666",
  transition: "transform 0.2s",
});

const listStyle = {
  position: "absolute",
  top: "100%",
  left: 0,
  right: 0,
  maxHeight: 200,
  margin: 0,
  padding: 0,
  listStyle: "none",
  overflowY: "auto",
  background: "#FFF",
  border: "1px solid #E6EDFF",
  borderRadius: 4,
  zIndex: 2000,
};

const itemStyle = isSelected => ({
  padding: "8px 12px",
  cursor: "pointer",
  background: isSelected ? "#F0F5FF" : "transparent",
});

const noOptStyle = {
  padding: "8px 12px",
  color: "#999",
  fontStyle: "italic",
};

export default function CustomSelect({
  name,
  value,
  onChange,
  placeholder,
  options,
  style = {},            // <-- añadida prop style
}) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const onClickOutside = e => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  const filtered = options.filter(o =>
    o.label.toLowerCase().includes((value || "").toLowerCase())
  );

  return (
    <div
      ref={wrapperRef}
      style={{
        ...wrapperStyle,
        ...style         // <-- aquí aplicamos los estilos externos
      }}
    >
      <input
        name={name}
        value={value}
        placeholder={placeholder}
        onFocus={() => setOpen(true)}
        onChange={e => {
          onChange(e);
          setOpen(true);
        }}
        style={inputStyle}
      />
      <span style={arrowStyle(open)} onClick={() => setOpen(o => !o)}>
        ▼
      </span>

      {open && (
        <ul style={listStyle}>
          {filtered.map(opt => (
            <li
              key={opt.value}
              onClick={() => {
                onChange({ target: { name, value: opt.value } });
                setOpen(false);
              }}
              style={itemStyle(opt.value === value)}
            >
              {opt.label}
            </li>
          ))}
          {filtered.length === 0 && <li style={noOptStyle}>(Sin opciones)</li>}
        </ul>
      )}
    </div>
  );
}